<template>
  <div class="e-school-header mb-5">
    <nav class="navbar navbar-expand-md navbar-light fixed-top bg-white">
      <div class="container">
        <a class="navbar-brand" href="#">
          <img :src="logoBrand" style="height: 63px" alt="brand-logo" />
        </a>

        <div class="d-inline-flex" id="navbarTogglerDemo02">
          <h6 class="login mx-3 fw-bold align-self-center">
            <a :href="getLoginUrl()">
              Log in
              <img
                :src="resolveImage('Icon-sign-in-alt-solid.jpg')"
                width="20"
                height="20"
                class="img-fluid"
                alt="sign-in"
              />
            </a>
          </h6>
          <button
            class="btn my-2 my-sm-0 apply-btn"
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#applyNow"
          >
            Apply now
          </button>
        </div>
      </div>
    </nav>
    <RegisterSteps />
  </div>
</template>

<script setup>
import RegisterSteps from './registerSteps.vue'

// Webpack's dynamic image loading using require.context
const imageContext = require.context('@/assets/images', false, /\.(png|jpe?g|svg)$/)

const resolveImage = (fileName) => {
  try {
    return imageContext(`./${fileName}`)
  } catch (e) {
    console.error(`Image "${fileName}" not found`)
    return ''
  }
}

// Logo image path
const logoBrand = resolveImage('afgc_logo.png')

// Compute login URL based on subdomain
const getLoginUrl = () => {
  const host = window.location.host
  const subdomain = host.split('.')[0]

  if (subdomain === 'dev') return 'https://dev.au.asu.edu/portal/'
  if (subdomain.includes('test')) return 'https://test.au.asu.edu/portal/'
  return 'https://au.asu.edu/portal/'
}
</script>

<style scoped lang="scss">
.navbar {
  position: fixed !important;
  top: -1px;
  left: 0px;
  height: 90px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  opacity: 1;
  border-bottom: 5px solid #0f152e;
}

.apply-btn {
  border: 0.5px solid #000000;
  background-color: white;
  border-radius: 25px;
  font-size: 1rem;
  font-weight: 600;
  padding-left: 15px;
  padding-right: 15px;
}

#navbarTogglerDemo02 {
  background: white;
  border-radius: 0 0 12px 12px;
}

.modal-dialog {
  width: 730px;
  max-width: 730px;
  top: 5%;
  position: relative !important;
}

@media screen and (max-width: 767px) {
  .modal-dialog {
    width: 100%;
    max-width: 730px;
    position: relative !important;
  }
}

.modal-header {
  background: #ffffff;
  border-bottom: none;
}

.close {
  color: #191919 !important;
}

.font36 {
  font-size: 36px !important;
}

.btn-primary {
  border-radius: 18px;
  padding: 4px 18px;
  border: none;
  font-weight: 700;
  text-transform: capitalize;
  background: #00306d;
  color: white;
  font-size: 16px;
}

.modal-body span {
  line-height: 1.8;
}
</style>
